<template>
  <div style="height: 100%">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">系统管理&nbsp;/&nbsp;</div>
        <div class="box-header-left-text">用户管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>审核</div>
        </div>
      </div>
    </div>
    <div class="section" style="padding: 0;padding-bottom: 20px;">
      <div class="box box-between p-15">
        <div class="box box-column-center">
          <img src="@/assets/image/company1.png" style="width: 72px;height: 72px;margin-right: 16px;">
          <div>
            <div class="topName">商户名称：{{ formInline.pbmc }}</div>
            <div class="topThx">统一社会信用代码：{{ formInline.tyshxydm }}</div>
          </div>
        </div>
        <div class="box">
          <el-button
            style="font-size: 16px"
            @click="cancel"
            size="mini"
            >
            <template class="box box-column-center">
              <!-- <img src="@/assets/image/back.png" style="width: 14px; height: 14px;margin-right: 5px;" /> -->
              <span>返回</span>
            </template>
            </el-button
          >
        </div>
      </div>
      <div class="line"></div>
      <div class="box box-column p-15 border-bottom mb-20">
        <div class="title mb-20">商户审核</div>
        <div class="box box-column-center mb-20">
          <span style="width: 150px; margin-bottom: 5px;">审核结果：</span>
          <el-radio-group v-model="radio">
            <el-radio label="pass">通过</el-radio>
            <el-radio label="reject">不通过</el-radio>
          </el-radio-group>
        </div>
        <div class="box mb-20 box-column-center">
          <span style="width: 150px;">上报人联系电话：</span>
          <el-input
            placeholder="请输入"
            v-model="formInline.phone"
            style="width: 250px;"
          >
          </el-input>
        </div>
        <div class="box mb-20">
          <span style="width: 150px;">审核意见：</span>
          <el-input
            class="box-1"
            :rows="2"
            type="textarea"
            placeholder="请输入内容"
            v-model="message"
            maxlength="100"
            show-word-limit
          >
          </el-input>
        </div>
        <div class="title mb-20">基本信息</div>
        <div class="info box box-column">
          <!-- <div class="box box-1">
            <div class="box-1 item tagBg">牌匾名称</div>
            <div class="box-7 item-bottom item-right">
              {{ formInline.pbmc }}
              <el-input v-model="formInline.pbmc" placeholder="请输入"></el-input>
            </div>
            <div class="box-1 item-bottom"></div>
            <div class="box-1 item-right"></div>
          </div> -->
          <!-- <div class="box box-1">
            <div class="box-1 item tagBg">牌匾名称</div>
            <div class="box-7 item-bottom item-right">
              {{ formInline.pbmc }}
            </div>
          </div> -->
          <div class="box box-1">
            <div class="box-1 item tagBg">牌匾名称</div>
            <div class="box-3 item">
              {{ formInline.pbmc }}
            </div>
            <div class="box-1 item tagBg">是否营业</div>
            <div class="box-3 item">
              {{ formInline.sfyy }}
            </div>
          </div>
          <div class="box box-1">
            <div class="box-1 item tagBg">负责人</div>
            <div class="box-3 item">
              {{ formInline.zrr }}
            </div>
            <div class="box-1 item tagBg">负责人联系电话</div>
            <div class="box-3 item">
              {{ formInline.zrrsjh }}
            </div>
          </div>
          <div class="box box-1">
            <div class="box-1 item tagBg">所属片区</div>
            <div class="box-3 item">
              {{ formInline.pian }}
            </div>
            <div class="box-1 item tagBg">所属社区</div>
            <div class="box-3 item">
              {{ formInline.sq }}
            </div>
          </div>
          <div class="box box-1">
            <div class="box-1 item tagBg">社区负责人</div>
            <div class="box-3 item">{{ formInline.sqfzr }}</div>
            <div class="box-1 item tagBg">社区负责人手机号</div>
            <div class="box-3 item">{{ formInline.sqfzrsjh }}</div>
          </div>
          <div class="box box-1">
            <div class="box-1 item tagBg">执法队负责人</div>
            <div class="box-3 item">{{ formInline.zfdfzr }}</div>
            <div class="box-1 item tagBg">执法队负责人手机号</div>
            <div class="box-3 item">{{ formInline.zfdfzrsjh }}</div>
          </div>
          <div class="box box-1">
            <div class="box-1 item tagBg">所属联盟</div>
            <div class="box-3 item">
              {{ formInline.zu }}
            </div>
            <div class="box-1 item tagBg">所属道路</div>
            <div class="box-3 item">
              {{ formInline.dlmc }}
            </div>
          </div>
          <div class="box box-1">
            <div class="box-1 item tagBg">责任人主体名称</div>
            <div class="box-3 item">
              {{ formInline.zrztmc }}
            </div>
            <div class="box-1 item tagBg">责任人主体地址</div>
            <div class="box-3 item">
              {{ formInline.zrztdz }}
            </div>
          </div>
          
          <div class="box box-1">
            <div class="box-1 item tagBg">上报人</div>
            <div class="box-3 item">
              {{ formInline.userName }}
            </div>
            <div class="box-1 item tagBg">上报人联系电话</div>
            <div class="box-3 item">
              {{ formInline.phone }}
            </div>
          </div>
          <!-- <div class="box box-1">
            <div class="box-1 item tagBg">上报人微信昵称</div>
            <div class="box-3 item">
              {{ formInline.wxNickname }}
            </div>
            <div class="box-1 item tagBg"></div>
            <div class="box-3 item"></div>
          </div> -->
          <div class="box box-1">
            <div class="box-1 item tagBg">门店照片</div>
            <div class="box-3 item-bottom box box-wrap">
              <el-image v-for="(item,index) in formInline.shanghuApplyImg && formInline.shanghuApplyImg.split(',')" :key="index" :src="item" class="image" :preview-src-list="formInline.shanghuApplyImg && formInline.shanghuApplyImg.split(',')"></el-image>
            </div>
            <div class="box-1 item-bottom"></div>
            <div class="box-3 item-right"></div>
          </div>
        </div>
        <div class="title mt-20 mb-20">所在地址</div>
        <div class="map-content mb-20">
          <MapCom :pointInfo="detailHandleList"></MapCom>
        </div>
        <div class="box box-column-center">
          <i class="el-icon-location-outline mr-10"></i>
          <span>{{ formInline.zrztdz }}</span>
        </div>
      </div>
      <div class="box box-column-center box-end submitFlag">
        <el-button
        style="font-size: 16px"
        @click="cancel"
        size="mini">
          取消
        </el-button>
        <el-button
        style="font-size: 16px;margin-right: 16px;"
        @click="submit"
        type="primary"
        size="mini">
          提交
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
checkStaff,
getUserDetail
} from "@/api/systemManagement";
import MapCom from "./map.vue";
export default {
  props: {
    dialogType: {
      type: String,
      default: ''
    },
    currentItem: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    MapCom
  },
  data () {
    return {
      // 审核结果：通过、不通过
      radio: '',
      // 审核意见
      message: '',
      // 审核意见
      applyContent: '',
      detailHandleList: {
        reportAddressLong: '117.20391594886048',
        reportAddressLat: '39.116957599893084'
      },
      dialogTableVisible: false,
      formInline: {}
    }
  },
  async mounted () {
    this.detailHandleList = {
      reportAddressLong: this.currentItem.longitude || 0,
      reportAddressLat: this.currentItem.latitude || 0
    }
    let res = await getUserDetail(this.currentItem.formShId);
    if (res.data.code == 200) this.formInline = {
      ...this.currentItem,
      ...res.data.data
    }
    // this.formInline = JSON.parse(JSON.stringify(this.currentItem));
    this.radio = this.formInline.zcCheckStatus == 'pass' ? this.formInline.zcCheckStatus : this.formInline.zcCheckStatus == 'reject' ? this.formInline.zcCheckStatus : '';
    this.message = this.formInline.zcCheckOpinion || '';
  },
  methods: {
    // 取消
    cancel () {
      this.$emit('closeDialog');
    },
    // 提交
    async submit () {
      console.log(this.formInline)
      if (!this.formInline.phone) return this.$message.error('请输入上报人联系电话')
      if (!this.radio) return this.$message.error('请选择审核结果');
      if (this.radio == 'reject' && !this.message) return this.$message.error('请输入审核意见');
      let params = {
        zcCheckOpinion: this.message,
        zcCheckStatus: this.radio,
        // roleIds: roleIds,
        id: this.formInline.formShId,
        phone: this.formInline.phone
      }
      let res = await checkStaff(params)
      if (res.data.code == 200) {
        this.$message.success('提交成功');
        this.$emit('closeDialog');
      } else this.$message.error(res.data.msg)
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/components/less.less";
* {
  font-size: 16px;
}
.cl-primary {
  color: #008CFF;
}
.topName {
  font-family: MiSans;
  font-size: 24px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0px;
  color: #494C4F;
}
.topThx {
  font-family: MiSans;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0px;
  color: #0054FE;
}
.box {
  display: flex;
}
.box-1 {
  flex: 1;
}
.box-2 {
  flex: 2;
}
.box-3 {
  flex: 3;
}
.box-4 {
  flex: 4;
}
.box-5 {
  flex: 5;
}
.box-6 {
  flex: 6;
}
.box-7 {
  flex: 7.25;
}
.box-wrap {
  flex-wrap: wrap;
}
.box-column {
  flex-direction: column;
}
.box-column-center {
  align-items: center;
}
.box-center {
  justify-content: center;
}
.box-center {
  justify-content: center;
  align-items: center;
}
.box-between {
  justify-content: space-between;
}
.border-bottom {
  border-bottom: 1px solid #E5EAF1;
}
.box-end {
  justify-content: flex-end;
}
.line {
  width: 100%;
  height: 16px;
  background: #f5f6f7;
}

.info {
  border-top: 1px solid #DFE5E8;
  border-left: 1px solid #DFE5E8;
  .item {
    padding: 14px 12px;
    border-right: 1px solid #DFE5E8;
    border-bottom: 1px solid #DFE5E8;
  }
  .item-right {
    padding: 14px 12px;
    border-right: 1px solid #DFE5E8;
    border-bottom: 1px solid #DFE5E8;
  }
  .item-bottom {
    padding: 14px 12px;
    border-bottom: 1px solid #DFE5E8;
  }
  .item-none {
    padding: 14px 12px;
  }
  .tagBg {
    background: #F1F4F6;
  }
  .image {
    width: 88px;
    height: 88px;
    border-radius: 8px;
    margin: 0;
    margin-right: 8px;
    margin-bottom: 8px;
  }
}
.p-15 {
  padding: 15px;
}
.pb-10 {
  padding-bottom: 10px;
}
.pb-20 {
  padding-bottom: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mr-10 {
  margin-right: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.bold {
  font-weight: bold;
}
.w100 {
  width: 130px;
}
.mb-10 {
  margin-bottom: 10px;
}
.pointer {
  cursor: pointer;
}
.mt-16 {
  margin-top: 16px;
}

.title {
  height: 17px;
  font-family: MiSans;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 18px;
  color: #494C4F;
  padding-left: 10px;
  position: relative;
  &::before {
    position: absolute;
    content: '';
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 4px;
    height: 17px;
    background: #0054FE;
  }
}

// .submitFlag {
//   position: absolute;
//   bottom: 0;
//   right: 0;
//   padding: 10px;
//   background: #fff;
// }
</style>


// WEBPACK FOOTER //
// src/pages/AuthenticationAuthority/userManagement/shshDetail.vue